import React from "react";
import {Route, Switch} from "react-router-dom";
import UsersSections from "../PanelSections/UsersSections";
import ContactUsSections from "../PanelSections/ContactUsSections";
import PodcastsSections from "../PanelSections/PodcastsSections";
import VideosSections from "../PanelSections/VideosSections";
import EventsSections from "../PanelSections/EventsSections";
import CounselingSections from "../PanelSections/CounselingSections";
import BlogsSections from "../PanelSections/BlogsSections";
import CommentsSections from "../PanelSections/CommentsSections";
import TicketsSections from "../PanelSections/TicketsSections";
import BasketsSections from "../PanelSections/BasketsSections";
import CouponsSections from "../PanelSections/CouponsSections";
import ProductsSections from "../PanelSections/ProductsSections";
import VideoProductsSections from "../PanelSections/VideoProductsSections";
import TeachersSections from "../PanelSections/TeachersSections";
import CategoriesForVideoProductsSections from "../PanelSections/CategoriesForVideoProductsSections";
import FilesForCategoryInVideoProductsSections from "../PanelSections/FilesForCategoryInVideoProductsSections";
import PurchasesSections from "../PanelSections/PurchasesSections";
import PaymentsSections from "../PanelSections/PaymentsSections";

const PanelRoute: React.FC = () => {
    return (
        <Switch>
            <Route path="/dashboard/users/:type" component={UsersSections}/>
            <Route path="/dashboard/purchases/:type" component={PurchasesSections}/>
            <Route path="/dashboard/baskets/:type" component={BasketsSections}/>
            <Route path="/dashboard/coupons/:type" component={CouponsSections}/>
            <Route path="/dashboard/podcasts/:type" component={PodcastsSections}/>
            <Route path="/dashboard/products/:type" component={ProductsSections}/>
            <Route path="/dashboard/teachers/:type" component={TeachersSections}/>
            <Route path="/dashboard/payments/:type" component={PaymentsSections}/>
            <Route path="/dashboard/videos-products/:type" component={VideoProductsSections}/>
            <Route path="/dashboard/categories-video-products/:type" component={CategoriesForVideoProductsSections}/>
            <Route path="/dashboard/files-categories/:type" component={FilesForCategoryInVideoProductsSections}/>
            <Route path="/dashboard/videos/:type" component={VideosSections}/>
            <Route path="/dashboard/events/:type" component={EventsSections}/>
            <Route path="/dashboard/blogs/:type" component={BlogsSections}/>
            <Route path="/dashboard/tickets/:type" component={TicketsSections}/>
            <Route path="/dashboard/comments/:type" component={CommentsSections}/>
            <Route path="/dashboard/counseling" component={CounselingSections}/>
            <Route path="/dashboard/contactUs" component={ContactUsSections}/>
        </Switch>
    )
}

export default PanelRoute